import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UpdatePasswordForm from '../components/UpdatePasswordForm'; // Var olan formunuzu import ediyoruz
import { supabase } from '../webSupabaseClient';

function UpdatePasswordPage() {
    const navigate = useNavigate();

    // Bu useEffect, sayfa yüklendiğinde URL'deki token'ı Supabase'in işlemesini sağlar.
    // Kullanıcı bu sayfaya e-posta linkinden geldiğinde, URL'de #access_token=... gibi bir bölüm olur.
    // onAuthStateChange bu bölümü algılar ve kullanıcıyı "şifre kurtarma" moduna sokar.
    useEffect(() => {
        const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
            if (event === 'PASSWORD_RECOVERY') {
                // Bu event, kullanıcının yeni şifre belirlemeye hazır olduğu anlamına gelir.
                // Token zaten Supabase tarafından işlenmiştir, artık form görünebilir.
            }
        });

        // Component DOM'dan ayrıldığında listener'ı temizle
        return () => {
            subscription.unsubscribe();
        };
    }, []);

    // Şifre başarıyla güncellendikten sonra kullanıcıyı giriş sayfasına yönlendir.
    const handleSuccess = () => {
        navigate('/auth'); 
    };

    return (
        <div className="flex items-center justify-center py-12">
            <div className="w-full max-w-md p-6 sm:p-8 space-y-6 bg-white rounded-lg shadow-md">
                {/* Var olan UpdatePasswordForm component'inizi burada kullanıyoruz. */}
                {/* Orijinal component'inizdeki 'closeModal' yerine 'onSuccess' prop'u ile yönlendirme yapıyoruz. */}
                <UpdatePasswordForm onSuccess={handleSuccess} />
            </div>
        </div>
    );
}

export default UpdatePasswordPage;